export default __webpack_public_path__ + "static/media/resume.5beb474a.svg";